export default __webpack_public_path__ + "static/bone-icons-91a9241a332a5984ac4c9077be489c67.png";